import type { DragEvent } from 'react';

export const CHAT_DRAG_MIME = 'application/x-littlebird-chat';

const IGNORE_CHAT_DRAG_START_SELECTOR =
  'button, input, textarea, [contenteditable="true"]';

export function beginChatDrag(
  event: DragEvent<HTMLElement>,
  threadId: string
): void {
  if (
    event.target instanceof Element &&
    event.target.closest(IGNORE_CHAT_DRAG_START_SELECTOR)
  ) {
    event.preventDefault();
    return;
  }

  event.dataTransfer.setData(CHAT_DRAG_MIME, threadId);
  event.dataTransfer.effectAllowed = 'move';
}

export function isChatDrag(dataTransfer: DataTransfer | null): boolean {
  return (
    dataTransfer !== null &&
    Array.from(dataTransfer.types).includes(CHAT_DRAG_MIME)
  );
}

export function getChatDragThreadId(
  dataTransfer: DataTransfer | null
): string | null {
  const threadId = dataTransfer?.getData(CHAT_DRAG_MIME);
  return threadId ? threadId : null;
}

const CHAT_DRAG_SCROLL_EDGE_PX = 64;
const CHAT_DRAG_SCROLL_STEP_PX = 20;

export function scrollChatDragList(
  event: { clientY: number; dataTransfer: DataTransfer | null },
  list: { scrollBy: (offset: number) => void } | null,
  listTop: number
): void {
  if (!list || !isChatDrag(event.dataTransfer)) return;
  if (event.clientY >= listTop + CHAT_DRAG_SCROLL_EDGE_PX) return;
  list.scrollBy(-CHAT_DRAG_SCROLL_STEP_PX);
}
